var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicensedReferee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1588 24.1853C45.1588 29.7262 41.4351 34.0557 37.0246 34.0557C32.614 34.0557 28.8904 29.7262 28.8904 24.1853C28.8904 18.6444 32.614 14.3149 37.0246 14.3149C41.4351 14.3149 45.1588 18.6444 45.1588 24.1853Z",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7778 39.0186H43.2306C52.6056 39.0186 60.2367 46.4853 60.5013 55.7963H14.5071C14.7717 46.4853 22.4028 39.0186 31.7778 39.0186Z",
    stroke: "#103B5D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37.0652,
    y1: 39.5063,
    x2: 37.0652,
    y2: 55.3088,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41.8618,
    y1: 39.5063,
    x2: 41.8618,
    y2: 55.3088,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 46.6587,
    y1: 39.5063,
    x2: 46.6587,
    y2: 55.3088,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.2683,
    y1: 39.5063,
    x2: 32.2683,
    y2: 55.3088,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 27.4717,
    y1: 39.5063,
    x2: 27.4717,
    y2: 55.3088,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 22.6748,
    y1: 41.4817,
    x2: 22.6748,
    y2: 55.3088,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 18.3374,
    y1: 45.4321,
    x2: 18.3374,
    y2: 55.3087,
    stroke: "#103B5D"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 51.9148,
    y1: 41.4817,
    x2: 51.9148,
    y2: 55.3088,
    stroke: "#103B5D"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 56.7114,
    y1: 45.4321,
    x2: 56.7114,
    y2: 55.3087,
    stroke: "#103B5D"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 17.3779,
    y1: 46.4199,
    x2: 17.3779,
    y2: 55.3088,
    stroke: "#103B5D"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 50.9556,
    y1: 40.4939,
    x2: 50.9556,
    y2: 55.3087,
    stroke: "#103B5D"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 55.7522,
    y1: 44.4446,
    x2: 55.7522,
    y2: 55.3088,
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2395 53.143L52.7856 50.5715L46.9999 60.5927L50.5126 59.6515L51.4538 63.1641L57.2395 53.143Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1682 50.5714L54.7144 53.1428L60.5001 63.164L61.4413 59.6513L64.9539 60.5925L59.1682 50.5714Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4385 39.6468L56 39.5021L57.5615 39.6468L59.0698 40.076L60.4735 40.775L61.725 41.72L62.7814 42.8789L63.607 44.2122L64.1735 45.6745L64.4616 47.2159V48.7841L64.1735 50.3255L63.607 51.7878L62.7814 53.1211L61.725 54.28L60.4736 55.225L59.0698 55.924L57.5615 56.3532L56 56.4979L54.4385 56.3532L52.9302 55.924L51.5264 55.225L50.275 54.28L49.2186 53.1211L48.393 51.7878L47.8265 50.3255L47.5384 48.7841V47.2159L47.8265 45.6745L48.393 44.2122L49.2186 42.8789L50.275 41.72L51.5265 40.775L52.9302 40.076L54.4385 39.6468Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensedReferee);
export default __webpack_public_path__ + "static/media/Licensed_Referee.0096bbc3c44f767cb7d6bf469f7b64c3.svg";
export { ForwardRef as ReactComponent };